import { render, staticRenderFns } from "./BonusAdd.vue?vue&type=template&id=242c1274"
import script from "./BonusAdd.vue?vue&type=script&lang=js"
export * from "./BonusAdd.vue?vue&type=script&lang=js"
import style0 from "./BonusAdd.vue?vue&type=style&index=0&id=242c1274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports